import { render, staticRenderFns } from "./product-pricing.vue?vue&type=template&id=88c5816a&"
import script from "./product-pricing.vue?vue&type=script&lang=ts&"
export * from "./product-pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports